import Vue from 'vue'
import App from './App.vue'
import router from './router'

//Vendor Component
import VueScrollReveal from 'vue-scroll-reveal';
import VueNumberInput from '@chenfengyuan/vue-number-input';

//Using VueNumberInput
Vue.use(VueNumberInput);

// Using ScrollReveal's default configuration
Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal', // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
  mobile: false,
  delay: 100,
  duration: 300,
  distance: '20px',
  easing: 'ease-in-out',
  origin: 'bottom',
  scale: 1,
});

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
